export const setGoodsReducer = (goodsData) => {
    return {
        type: 'SET_GOODS_DATA',
        payload: goodsData,
    };
};

export const appendGoodsReducer = (goodsData) => {
    return {
        type: 'APPEND_GOODS_DATA',
        payload: goodsData,
    };
};

export const setGoodsParamsReducer = (paramsData) => {
    return {
        type: 'SET_GOODS_PARAMS_DATA',
        payload: paramsData,
    };
};

export const deleteGoodData = (id) => {
    return {
        type: 'DELETE_GOOD_DATA',
        payload: id
    };
};

export const updateGoodsData = (updatedGood) => {
    return {
        type: 'UPDATE_GOODS_DATA',
        payload: updatedGood,
    };
};


const initialState = {
    goods: [],
    params: {
        categoryID: 0,
        offset: 0,
        filter: 0,
        searchText: '',
        catalogID: 0,
    },
};

const goodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_GOODS_DATA':
            return {
                ...state,
                goods: Object.values(action.payload),
            };
        case 'APPEND_GOODS_DATA':
            const existingGoodsArray = Object.values(state.goods);
            const newGoodsArray = Object.values(action.payload);

            const combinedArray = [...existingGoodsArray, ...newGoodsArray];

            const newGoods = combinedArray.reduce((acc, item) => {
                
                acc.push(item);
                return acc;

            }, []);

            return {
                ...state,
                goods: newGoods
            };
        case 'SET_GOODS_PARAMS_DATA':
            return {
                ...state,
                params: action.payload,
            };
        case 'DELETE_GOOD_DATA':
            const remainingGoods = Object.values(state.goods).filter(good => {
                return good !== undefined && Number(good.id) !== Number(action.payload);
            });
            
            return {
                ...state,
                goods: { ...remainingGoods }
            };
        case 'UPDATE_GOODS_DATA':
            const updatedGoods = Object.values(state.goods).map(good => {
                if(good !== undefined) {
                    if (good.id === action.payload.id) {
                        return { ...good, ...action.payload };
                    }
                    return good;
                }
            });
            return {
                ...state,
                goods: updatedGoods
            };
        default:
            return state;
    }
};

export default goodsReducer;